<script setup>
import FieldInput from '../../../components/ui/FieldInput.vue';
import ModelAddress from '../models/address';
import decoder from '../../../lib/decoder';
import {checkDataElement} from "../../base";
import {nextTick} from "vue";

const model = defineModel();
const props = defineProps({
    dataElement: String,
});

if (!model.value) {
    model.value = new ModelAddress();
}
const fillAddressFieldsFromSuggestion = (item) => {
    if (!item || !item.data) {
        return
    }
    let data = item.data;

    let address = {
        postal_code: decoder.stringValue(data['postal_code'], ''),
        region: [
            decoder.stringValue(data['region_with_type'], ''),
            decoder.stringValue(data['area_with_type'], '')].filter(item => item).join(', '),
        city: [
            decoder.stringValue(data['city_with_type'], ''),
            decoder.stringValue(data['settlement_with_type'], '')].filter(item => item).join(', '),
        street: decoder.stringValue(data['street_with_type'], ''),
        house: decoder.stringValue(data['house'], ''),
        building: [
            decoder.stringValue(data['block_type'], ''),
            decoder.stringValue(data['block'], '')].filter(item => item).join(', '),
        flat: decoder.stringValue(data['flat'], '')
    };

    nextTick(() => {
        for (let key in address) {
            if (Object.hasOwnProperty.call(address, key) && address[key] !== '' && !model.value.fields[key].disabled ) {
                model.value.fields[key].value = address[key]
            }
        }
    });
};


</script>

<template>
    <div class="fields">
        <div class="row mb-3">
            <div class="col-sm-4 col-md-3">
                <FieldInput
                        v-model="model.fields.postal_code.value"
                        :disabled="model.fields.postal_code.disabled || model.disabled"
                        :error="model.fields.postal_code.error"
                        :data-element="checkDataElement(dataElement + '_postal_code_field')"
                        label="Индекс"
                />
            </div>
            <div class="col-sm-4 col-md-4">
                <FieldInput
                    v-model="model.fields.region.value"
                    :disabled="model.fields.region.disabled || model.disabled"
                    :error="model.fields.region.error"
                    :data-element="checkDataElement(dataElement + '_region_field')"
                    label="Область / край"
                    :suggestType="'address'"
                    @suggestSelect="fillAddressFieldsFromSuggestion"
                />
            </div>
            <div class="col-sm-6 col-md-5">
                <FieldInput
                        v-model="model.fields.city.value"
                        :disabled="model.fields.city.disabled || model.disabled"
                        :error="model.fields.city.error"
                        :data-element="checkDataElement(dataElement + '_city_field')"
                        label="Город"
                        :suggestType="'address'"
                        @suggestSelect="fillAddressFieldsFromSuggestion"
                />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-12 col-md-6">
                <FieldInput
                        v-model="model.fields.street.value"
                        :disabled="model.fields.street.disabled || model.disabled"
                        :error="model.fields.street.error"
                        :data-element="checkDataElement(dataElement + '_street_field')"
                        label="Улица"
                        :suggestType="'address'"
                        @suggestSelect="fillAddressFieldsFromSuggestion"
                />
            </div>
            <div class="col-sm-12 col-md-2">
                <FieldInput
                        v-model="model.fields.house.value"
                        :disabled="model.fields.house.disabled || model.disabled"
                        :error="model.fields.house.error"
                        :data-element="checkDataElement(dataElement + '_house_field')"
                        label="Дом"
                />
            </div>
            <div class="col-sm-12 col-md-2">
                <FieldInput
                        v-model="model.fields.building.value"
                        :disabled="model.fields.building.disabled || model.disabled"
                        :error="model.fields.building.error"
                        :data-element="checkDataElement(dataElement + '_building_field')"
                        label="Корп. / стр."
                />
            </div>
            <div class="col-sm-12 col-md-2">
                <FieldInput
                        v-model="model.fields.flat.value"
                        :disabled="model.fields.flat.disabled || model.disabled"
                        :error="model.fields.flat.error"
                        :data-element="checkDataElement(dataElement + '_flat_field')"
                        label="Квартира / офис"
                />
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "AddressBlock",
}
</script>